import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import CryptoJS from "crypto-js";
import { BehaviorSubject, Observable } from "rxjs";
import { Info, Parametros, Variables } from "../models/user.interface";
import { INavData } from "@coreui/angular";

const apiUrl = environment.apiURL;

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  token: string;
  user: Info;
  fecha: any;
  public menu: any;
  private currentUserSubject: BehaviorSubject<Info>;
  public currentUser: Observable<Info>;

  private parametrosGeneralesSubject: BehaviorSubject<any>;
  public parametrosGenerales: Observable<any>;

  private currentMenuSubject: BehaviorSubject<any>;
  public currentMenu: Observable<any>;

  private currentVariableTipoCambioSubject: BehaviorSubject<any>;
  public variableTipoCambio: Observable<any>;

  constructor(private http: HttpClient, private router: Router) {
    // user
    this.currentUserSubject = new BehaviorSubject<Info>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    // menu
    this.currentMenuSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("menu"))
    );
    this.currentMenu = this.currentMenuSubject.asObservable();
    // parametros
    this.parametrosGeneralesSubject = new BehaviorSubject<Parametros>(
      JSON.parse(localStorage.getItem("parametros"))
    );
    this.parametrosGenerales = this.parametrosGeneralesSubject.asObservable();
    // variable tipo Cambio
    this.currentVariableTipoCambioSubject = new BehaviorSubject<Variables>(
      JSON.parse(localStorage.getItem("variables"))
    );
    this.variableTipoCambio =
      this.currentVariableTipoCambioSubject.asObservable();
  }

  public get currentUserValue(): Info {
    return this.currentUserSubject.value;
  }

  public get currentMenuValue(): INavData[] {
    return this.currentMenuSubject.value;
  }

  public get currentParametroValue(): Parametros {
    return this.parametrosGeneralesSubject.value;
  }

  public get currentVariablesValue(): Variables {
    return this.currentVariableTipoCambioSubject.value;
  }

  cargarParametros() {
    return this.http.get<any>(`${apiUrl}api/par/generales`).pipe(
      map((res) => {
        this.parametrosGeneralesSubject.next(res.data);
        localStorage.setItem("parametros", JSON.stringify(res.data));
        this.fecha = localStorage.setItem("fecha", res.data.fechaLnCredito);
        return res;
      })
    );
  }

  cargarVariableActuales() {
    return this.http
      .get<any>(`${apiUrl}api/adm/tiposcambio/tipos/variablesactuales`)
      .pipe(
        map((res: any) => {
          localStorage.setItem("variables", JSON.stringify(res));
          this.currentVariableTipoCambioSubject.next(res);
          return res;
        })
      );
  }

  public isAuthenticated(): boolean {
    this.token = localStorage.getItem("token");
    this.menu = localStorage.getItem("menu");
    this.user = JSON.parse(localStorage.getItem("currentUser"));
    if (!this.token) {
      return false;
    } else {
      return true;
    }
  }

  logout() {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
    localStorage.removeItem("menu");
    localStorage.removeItem("recibo");
    localStorage.removeItem("parametros");
    localStorage.removeItem("fecha");
    localStorage.removeItem("variables");
    this.currentUserSubject.next(null);
    this.router.navigate(["/login"]);
  }

  Encry(text: string) {
    if (text !== "") {
      const key = CryptoJS.enc.Utf8.parse("hf8685nfhfhjs9h8");
      const iv = CryptoJS.enc.Utf8.parse("8080808080808080");
      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(text),
        key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      return encrypted;
    }
  }

  confirmarToken(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      })
    };

    return this.http
      .get<any>(`${apiUrl}api/SecMenu`, httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
